(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("qcharts"));
	else if(typeof define === 'function' && define.amd)
		define(["qcharts"], factory);
	else if(typeof exports === 'object')
		exports["QchartsReact"] = factory(require("qcharts"));
	else
		root["QchartsReact"] = factory(root["qcharts"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return 